/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/contact', children: 'contact' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/ContactLink.js